<div [matTooltipClass]="'regular-tooltip'" [matTooltip]="getTooltip()" matTooltipPosition="above">
  <mat-icon
    [ngClass]="[
      $safeNavigationMigration(params()?.cellOptions?.class),
      'icon-' + $safeNavigationMigration(params()?.cellOptions?.icon),
      'delay-' + $safeNavigationMigration(params()?.value)
    ]"
    [svgIcon]="$safeNavigationMigration(params()?.cellOptions?.icon)"
  />
</div>
